<mat-progress-spinner
  *ngIf="isLoading"
  class="loading-spinner"
  mode="indeterminate"
  [diameter]="40"
  style="margin: 0px auto"
></mat-progress-spinner>
<ng-container *ngIf="showCustomProperties">
  <div
    class="properties-container"
    [ngStyle]="{
      'grid-template-columns':
        columns > 1 ? 'repeat(' + columns + ', 1fr)' : '1fr',
      gap: columns > 1 ? '24px' : '0'
    }"
  >
    <div
      romaProSelect
      (isAvailableFeature)="isAvailableFeature($event)"
      [feature]="i < 2 ? featureRef.SystemPermission.DefaultAllow : feature"
      [options]="{
        className: 'roma-label warning right-center'
      }"
      class="wrapper-container wrapper-pro-feature-none"
      *ngFor="let property of dynamicProperties; let i = index"
      [attr.data-index]="i"
    >
      <div
        style="width: 100%; float: left; display: grid"
        romaProSelect
        class="form-group wrapper-pro-feature-user"
        [featureUser]="featureUser"
      >
        <div class="row">
          <div [ngClass]="rowLayout ? 'col-12' : 'col-5'">
            <label class="field-label" for="name">
              {{ property.name | translate }}
              <obligatory-field-sign
                *ngIf="property.isRequired"
              ></obligatory-field-sign>
            </label>
          </div>
          <div [ngClass]="rowLayout ? 'col-12' : 'col-7'">
            <roma-editable-field
              [smSize]="smSize"
              [value]="valueCustomProperty(property?._id)"
              [fieldName]="
                property.type !== dynamicPropertyTypeRef.Select
                  ? 'value'
                  : 'options'
              "
              [elements]="
                property.type === dynamicPropertyTypeRef.Select
                  ? property.options
                  : []
              "
              [type]="typeCustomProperty(property?.type)"
              [isCustomProperty]="true"
              [updateOnEdit]="updateOnEdit"
              [apiUrl]="':API_URL/dynamic-properties/schema-ref'"
              [params]="{ idCustomProperty: property._id, schemaID: idSchema }"
              [block]="false"
              [isMultiple]="property.type === dynamicPropertyTypeRef.Select"
              [showAlertMessage]="options.showAlertMessage"
              [isRequired]="property.isRequired"
              (checkInvalidField)="checkInvalidField($event)"
              (updateLoading)="isLoadingUpdate($event)"
              (requestedApi)="changeProperty()"
              (onValueChanged)="eventValueChanged(property, $event)"
            >
            </roma-editable-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="showAddButton && dynamicProperties.length"
    class="add-button-container"
    romaProFeature
    [featureUserHide]="featureRefUser.CompanyAdjust.update"
  >
    <button
      class="add-button"
      [ngClass]="{ margin: dynamicProperties.length > 0 }"
      (click)="addCustomProperty()"
    >
      <img src="assets/images/circle-plus.svg" />
      {{ 'customProperties.newField' | translate }}
    </button>
  </div>
</ng-container>

<div
  class="custom-fields-message"
  *ngIf="showAddButton && !dynamicProperties.length && !isLoading"
  romaProFeature
  [featureUserHide]="featureRefUser.CompanyAdjust.update"
>
  <span class="material-icons pointer info ng-star-inserted">info</span>
  <h4>{{ 'expense.messageTitle' | translate }}</h4>
  <a (click)="addCustomProperty()">
    {{ 'expense.messageButton' | translate }}
  </a>
</div>
